import RecommendSwitcher from "./_RecommendSwitcher";

const { $ } = window;

$(() => {
  /* eslint-disable camelcase */
  const { article_recommends } = window;
  // console.log("this is single-articles.js");
  const recommendSwitcher = new RecommendSwitcher(article_recommends);
});
